import React from 'react';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { ContractorsCard } from '../components/ContractorsCard';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

export default class ContractorsScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.CONTRACTORS,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_CONTRATISTAS')} breadcrumbs={breadcrumbs}>
                <ContractorsCard/>
            </PsPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/contractors/screens/ContractorsScreen.js